<template>
    <q-card-section class="vinculados-section">
        <q-expansion-item
            icon="link"
            label="Presupuestos Vinculados"
            header-class="text-subtitle1 text-weight-medium"
            class="vinculados-expansion"
        >
            <q-table
                :rows="rows"
                :columns="columns"
                row-key="id"
                flat
                dense
                :pagination="{ rowsPerPage: 0 }"
                hide-bottom
            >
                <template v-slot:body-cell-id="props">
                    <q-td :props="props">
                        <span class="id-badge" @click="verPresupuesto(props.row.id)">
                            #{{ props.row.id }}
                            <q-tooltip anchor="top middle" self="center middle">
                                Ver presupuesto
                            </q-tooltip>
                        </span>
                    </q-td>
                </template>
                <template v-slot:body-cell-estado="props">
                    <q-td :props="props">
                        <q-chip
                            :color="props.row.estado?.color"
                            text-color="white"
                            size="sm"
                        >
                            {{ props.row.estado?.nombre }}
                        </q-chip>
                    </q-td>
                </template>
                <template v-slot:body-cell-total="props">
                    <q-td :props="props" :class="props.value < 0 ? 'text-negative' : 'text-positive'">
                        {{ numberFormat(props.value) }}
                    </q-td>
                </template>
                <template v-slot:no-data>
                    <div class="full-width row justify-center text-grey q-py-md">
                        No hay presupuestos vinculados
                    </div>
                </template>
                <template v-slot:bottom-row>
                    <q-tr v-if="rows.length > 0">
                        <q-td colspan="3" class="text-right text-bold">Total</q-td>
                        <q-td
                            class="text-right text-bold"
                            :class="totalVinculados < 0 ? 'text-negative' : 'text-positive'"
                        >
                            {{ numberFormat(totalVinculados) }}
                        </q-td>
                    </q-tr>
                </template>
            </q-table>
        </q-expansion-item>
    </q-card-section>
</template>

<script setup>
import { computed } from "vue";
import numberFormat from "@/helpers/numberFormat";

const { presup } = defineProps({
    presup: Object,
});

const rows = computed(() => presup?.vinculados ?? []);

const columns = [
    { name: "id", label: "ID", field: "id", align: "left" },
    {
        name: "created_at",
        label: "Fecha",
        field: "created_at",
        align: "left",
        format: (val) => val?.split(" ")[0] ?? "-",
    },
    {
        name: "estado",
        label: "Estado",
        field: (val) => val.estado?.nombre,
        align: "left",
    },
    {
        name: "total",
        label: "Total",
        field: (row) => signedTotal(row),
        align: "right",
    },
];

const signedTotal = (row) => {
    const total = Number(row.items_sum_total ?? 0);
    return row.estado?.nombre === "ANULADO" ? total : -total;
};

const totalVinculados = computed(() =>
    rows.value.reduce((acc, row) => acc + signedTotal(row), 0),
);

const verPresupuesto = (id) => {
    window.open(`/presupuestos/${id}`, "_blank");
};
</script>

<style lang="scss" scoped>
.vinculados-section {
    background: linear-gradient(to bottom, #fafafa, #f5f5f5);
    padding: 24px;
}

.vinculados-expansion {
    background: white;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.id-badge {
    display: inline-block;
    background: linear-gradient(135deg, #e3f2fd, #bbdefb);
    color: #1565c0;
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;

    &:hover {
        background: linear-gradient(135deg, #bbdefb, #90caf9);
    }
}
</style>
